import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";
import {
  BreakPointTablet,
  BreakPointMobile,
} from "../../../constants/dimension";
import { getMediaSizeScale } from "../../../models/screen";

const GRADIENT = "linear-gradient(to right, #ee5585, #d8324f)";
const SOLID = "#d8324f";

export const useStyles = createUseStyles((theme: ITheme) => {
  const scale = getMediaSizeScale();
  const snap = (n: number) => Math.round(n * scale) / scale;
  const px = (n: number) => `${snap(n)}px`;

  return {
    tag: {
      position: "absolute",
      zIndex: theme.zIndex.normal,
      top: snap(-theme.spacing.space24),
      left: snap(-6),
      boxSizing: "border-box",
      display: "inline-block",
      maxWidth: "100%",
      overflow: "hidden",
      height: snap(46),
      lineHeight: `${px(46)} !important`,
      minWidth: snap(122),
      padding: `0 ${px(24)} 0 ${px(16)}`,
      marginLeft: "0px !important",
      whiteSpace: "nowrap",
      color: "#fff",
      textAlign: "center",
      "&::before, &::after": {
        content: `""`,
        position: "absolute",
        top: 0,
        bottom: 0,
      },
      "&::before": {
        left: 0,
        right: snap(30),
        zIndex: -1,
        borderRadius: `${px(15)} 0 0 ${px(12)}`,
        background: GRADIENT,
      },
      "&::after": {
        right: 0,
        width: snap(43),
        zIndex: -2,
        borderRadius: `0 ${px(16)} ${px(10)} 0`,
        background: SOLID,
        transform: "skewX(-24deg)",
        transformOrigin: "100% 0",
      },

      [BreakPointTablet]: {
        top: snap(-13),
        left: snap(-3),
        height: snap(25),
        lineHeight: `${px(25)} !important`,
        minWidth: snap(66),
        padding: `0 ${px(16)} 0 ${px(8)}`,
        fontSize: `${px(14)} !important`,
        "&::before": {
          right: snap(16),
          borderRadius: `${px(8)} 0 0 ${px(6)}`,
        },
        "&::after": {
          width: snap(23),
          borderRadius: `0 ${px(9)} ${px(5)} 0`,
        },
      },
      [BreakPointMobile]: {
        top: snap(-12),
        left: snap(-3),
        height: snap(23),
        lineHeight: `${px(23)} !important`,
        minWidth: snap(61),
        padding: `0 ${px(16)} 0 ${px(8)}`,
        fontSize: `${px(12)} !important`,
        "&::before": {
          right: snap(15),
          borderRadius: `${px(7)} 0 0 ${px(6)}`,
        },
        "&::after": {
          width: snap(21),
          borderRadius: `0 ${px(8)} ${px(5)} 0`,
        },
      },
    },

    // Narrower card columns on some pages; the label needs to be smaller to
    // fit on mobile.
    compact: {
      [BreakPointMobile]: {
        fontSize: `${px(10)} !important`,
      },
    },
  };
});
